import * as React from 'react'

const IconOfferWall = (isActive?, className?: string) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg"
             className={className ? className : ''} width="52" height="70" viewBox="0 0 52 70">
            <g fill="none" fillRule="evenodd" stroke={isActive ? '#ff6262' : '#4A4A83'} strokeWidth=".782">
                <path d="M47.184 23.943c.751 1.705 1.201 3.57 1.201 5.314v30.938c0 2.093-.646 3.611-1.687 4.365-1.009.731-7.757 4.49-7.797 4.515-.996.65-2.328.629-3.789-.216L6.593 52.365C3.507 50.579 1 45.785 1 41.665V10.727c0-2.178.7-3.734 1.815-4.454.996-.641 6.615-3.822 7.8-4.506.98-.567 2.26-.513 3.658.296l16.68 9.648"/>
                <path d="M40.705 33.69c0-4.119-2.506-8.913-5.593-10.699L6.593 6.497C3.507 4.71 1 6.607 1 10.727v30.938c0 4.12 2.507 8.914 5.593 10.7l28.519 16.494c3.087 1.786 5.593-.11 5.593-4.23V33.69zM5.248 32.589l6.351 3.666M8.423 38.088v-7.333"/>
                <path d="M13.123 33.774l2.952-3.099v12.369M29.287 38.303c1.884 1.088 3.413 4.745 3.413 8.162 0 3.417-1.53 5.308-3.413 4.219-1.884-1.088-3.413-4.746-3.413-8.163 0-3.416 1.529-5.306 3.413-4.218zM23.37 34.946l-4.156-2.399s-.035 3.34 0 4.743c.464-.12 1.011-.027 1.597.311 1.676.968 3.037 3.59 3.037 5.85s-1.36 3.307-3.037 2.34c-.925-.534-1.754-1.571-2.31-2.772M51.266 11.81v10.513l-3.39 1.956-16.922-9.76.028-11.561L34.372 1l3.673 7.46 1.568-1.62 3.196-1.712 4.235 9.121z"/>
                <path d="M43.655 16.206l4.222-2.438V24.28l-16.923-9.76V4.009l4.226 7.315 4.24-4.238 4.235 9.12z"/>
            </g>
        </svg>

    )
}

export default IconOfferWall


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/svg/iconOfferWall.tsx